import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";

import { I18nProvider } from "./contexts/I18nContext";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LaunchBanner from "./components/LaunchBanner";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import AdminLayout from "./components/AdminLayout";
import CookieBanner from "./components/CookieBanner";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Builder from "./pages/Builder";
import Pricing from "./pages/Pricing";
import InstallApp from "./pages/InstallApp";
import Policy from "./pages/Policy";
import SimpleMode from "./pages/SimpleMode";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminInvoices from "./pages/admin/AdminInvoices";
import AdminPolicies from "./pages/admin/AdminPolicies";
import { Toaster } from "sonner";

function ChromeLayout() {
  const location = useLocation();
  const hideNav = location.pathname.startsWith("/a/");
  return (
    <>
      {!hideNav && <LaunchBanner />}
      {!hideNav && <Navbar />}
      <main className={hideNav ? "" : "min-h-[60vh]"}>
        <Outlet />
      </main>
      {!hideNav && <Footer />}
      {!hideNav && <CookieBanner />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<ChromeLayout />}>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/legal/:slug" element={<Policy />} />
                <Route path="/quick" element={<SimpleMode />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/builder" element={<ProtectedRoute><Builder /></ProtectedRoute>} />
                <Route path="/builder/:id" element={<ProtectedRoute><Builder /></ProtectedRoute>} />
                <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="invoices" element={<AdminInvoices />} />
                  <Route path="policies" element={<AdminPolicies />} />
                </Route>
                <Route path="/a/:slug" element={<InstallApp />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
